import type { Call } from '@entities/call';
import type { BaseUsecase } from '@usecases/base-usecase';

export type HangupTransferCallRequest = void;

export interface HangupTransferCallRepository {
  fetchTransferCall(): Promise<Call>;
}

export interface HangupTransferCallEventPublisher {
  publish(): Promise<void>;
}

export interface HangupTransferCallUsecase
  extends BaseUsecase<HangupTransferCallRequest, void> {
  run(): Promise<void>;
}

export class HangupTransferCall implements HangupTransferCallUsecase {
  constructor(
    private repository: HangupTransferCallRepository,
    private publisher: HangupTransferCallEventPublisher,
  ) {}

  async run(): Promise<void> {
    const _call = await this.repository.fetchTransferCall();
    await Promise.all([
      this.publisher.publish(),
      // this.repository.removeTransferCalls(),
    ]);
  }
}
